import { ADD, DISMISS, type AddFlagAction, type DismissFlagAction } from './actions';
import type { Flag, FlagState } from './types';

type Action = AddFlagAction | DismissFlagAction;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: FlagState = [], action: Action): Flag[] => {
	switch (action.type) {
		case ADD:
			// prepend new flag to allow flag group show fancy animation
			return [action.payload, ...state];
		case DISMISS:
			return state.filter((flag: Flag) => flag.id !== action.payload);
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
